import { useCurrentModule } from '../components';
export const useProductHat = _ref => {
  let {
    productId
  } = _ref;
  const module = useCurrentModule();
  const {
    data: product
  } = module.SDK.studioOfferingApiClient.hooks.useFetchProduct({
    productId
  });
  const {
    t
  } = module.internals.useTranslations();
  const {
    recommendedDisplayText,
    isRecommended
  } = product ?? {};
  const {
    data: {
      isCurrentProduct
    } = {
      isCurrentProduct: false
    }
  } = module.SDK.switchApiClient.hooks.useIsCurrentProduct({
    productId
  });
  const hasHat = isCurrentProduct || isRecommended;
  const text = isCurrentProduct ? t('premium-purchase-plan.cards.hat.current_plan') : isRecommended ? recommendedDisplayText == null ? void 0 : recommendedDisplayText.toUpperCase() : undefined;
  const background = isCurrentProduct ? '#EBEBEB' : '#A6FFD8';
  return {
    text,
    background,
    hasHat
  };
};
//# sourceMappingURL=useProductHat.js.map